/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  GuangGaoChaXunTiaoJian,
  GuangGaoChuangJianShiTiLei,
  GuangGaoGengXinXinXi,
  GuangGaoZhuangTaiGengXinXinXi,
  PiLiangGuangGaoYuSuanBianJi,
  ResponseApi,
  ResponseApiGuangGaoLieBiaoXiangYing,
  ResponseApiGuangGaoXiangQing,
  ResponseApiIPageGuangGaoLieBiaoXiangYing,
  ResponseApiLong,
  ResponseApiVoid,
} from "./data-contracts";
import { HttpClient, RequestParams, ContentType } from '@gatherstar/utils';

export class GuangGaoGuanLi<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags GuangGaoGuanLi
   * @name BatchUpdateAdBudgetUsingPut
   * @summary 批量更新广告预算
   * @request PUT:/dsp-admin/api/ad/batch/budget
   * @secure
   */
  batchUpdateAdBudgetUsingPut = (
    batchBudgetUpdateDTO: PiLiangGuangGaoYuSuanBianJi,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiVoid, void>({
      path: `/dsp-admin/api/ad/batch/budget`,
      method: "PUT",
      body: batchBudgetUpdateDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description 专门用于批量更新广告状态的接口。状态值：0-删除, 1-投放中, 2-暂停, 3-已完成
   *
   * @tags GuangGaoGuanLi
   * @name BatchUpdateAdStatusUsingPut
   * @summary 批量更新广告状态
   * @request PUT:/dsp-admin/api/ad/batch/status
   * @secure
   */
  batchUpdateAdStatusUsingPut = (
    statusDTO: GuangGaoZhuangTaiGengXinXinXi,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiVoid, void>({
      path: `/dsp-admin/api/ad/batch/status`,
      method: "PUT",
      body: statusDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags GuangGaoGuanLi
   * @name GetAdDetailUsingPost
   * @summary 获取广告详情（包括完整的计划、广告组、创意信息）
   * @request POST:/dsp-admin/api/ad/campaign/{campaignId}
   * @secure
   */
  getAdDetailUsingPost = (campaignId?: number, params: RequestParams = {}) =>
    this.request<ResponseApiGuangGaoXiangQing, void>({
      path: `/dsp-admin/api/ad/campaign/${campaignId}`,
      method: "POST",
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags GuangGaoGuanLi
   * @name CreateAdUsingPost
   * @summary 创建广告
   * @request POST:/dsp-admin/api/ad/create
   * @secure
   */
  createAdUsingPost = (
    createDTO: GuangGaoChuangJianShiTiLei,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiLong, void>({
      path: `/dsp-admin/api/ad/create`,
      method: "POST",
      body: createDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags GuangGaoGuanLi
   * @name AdListUsingPost
   * @summary 分页查询广告列表
   * @request POST:/dsp-admin/api/ad/list
   * @secure
   */
  adListUsingPost = (
    queryDTO: GuangGaoChaXunTiaoJian,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiIPageGuangGaoLieBiaoXiangYing, void>({
      path: `/dsp-admin/api/ad/list`,
      method: "POST",
      body: queryDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description 支持单个或批量更新广告状态。状态值：0-删除, 1-投放中, 2-暂停, 3-已完成
   *
   * @tags GuangGaoGuanLi
   * @name UpdateAdStatusUsingPut
   * @summary 更新广告状态
   * @request PUT:/dsp-admin/api/ad/status
   * @secure
   */
  updateAdStatusUsingPut = (
    statusDTO: GuangGaoZhuangTaiGengXinXinXi,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApi, void>({
      path: `/dsp-admin/api/ad/status`,
      method: "PUT",
      body: statusDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags GuangGaoGuanLi
   * @name GetAdByIdUsingPost
   * @summary 获取广告信息
   * @request POST:/dsp-admin/api/ad/{adId}
   * @secure
   */
  getAdByIdUsingPost = (adId?: number, params: RequestParams = {}) =>
    this.request<ResponseApiGuangGaoLieBiaoXiangYing, void>({
      path: `/dsp-admin/api/ad/${adId}`,
      method: "POST",
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags GuangGaoGuanLi
   * @name UpdateAdUsingPut
   * @summary 更新广告
   * @request PUT:/dsp-admin/api/ad/{adId}
   * @secure
   */
  updateAdUsingPut = (
    updateDTO: GuangGaoGengXinXinXi,
    adId?: number,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiLong, void>({
      path: `/dsp-admin/api/ad/${adId}`,
      method: "PUT",
      body: updateDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags GuangGaoGuanLi
   * @name DeleteAdUsingDelete
   * @summary 删除广告
   * @request DELETE:/dsp-admin/api/ad/{adId}
   * @secure
   */
  deleteAdUsingDelete = (adId?: number, params: RequestParams = {}) =>
    this.request<ResponseApiVoid, void>({
      path: `/dsp-admin/api/ad/${adId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
}


// 导出默认实例，可直接使用
export const api = new GuangGaoGuanLi();
